import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, Fragment, memo, useEffect, useMemo, useState, } from 'react';
/* eslint-disable-next-line react/display-name */
const ResponsiveImage = forwardRef(({ alt, className, fallbackComponent, imageLoading, imageSources, sizes, }, ref) => {
    const [currentSrcIndex, setCurrentSrcIndex,] = useState(0);
    const [hasError, setHasError,] = useState(false);
    const handleError = () => {
        if (currentSrcIndex < imageSources.length - 1) {
            setCurrentSrcIndex((prevIndex) => (prevIndex + 1));
        }
        else {
            setHasError(true);
        }
    };
    const currentSource = useMemo(() => (imageSources[currentSrcIndex]), [
        imageSources,
        currentSrcIndex,
    ]);
    useEffect(() => {
        setHasError(false);
        setCurrentSrcIndex(0);
    }, [
        imageSources,
    ]);
    return (hasError
        ? (_jsx(Fragment, { children: fallbackComponent }))
        : (_jsx("img", { alt: alt, className: className, loading: imageLoading, onError: handleError, ref: ref, sizes: sizes, src: currentSource.src, srcSet: currentSource.srcSet })));
});
const MemoizedResponsiveImage = memo(ResponsiveImage);
export { MemoizedResponsiveImage as ResponsiveImage };
// MC-1068 Temporary hack for Storybook.
export default ResponsiveImage;
